import React from 'react';
import Button from '../../../components/ui/Button';

const FormNavigation = ({ 
  currentStep, 
  totalSteps, 
  onPrevious, 
  onNext, 
  onSave, 
  isValid,
  isSaving 
}) => {
  // Determine if we're on the final step
  const isFinalStep = currentStep === totalSteps - 1;

  return (
    <div className="sticky bottom-0 bg-white border-t border-gray-200 shadow-lg z-10">
      <div className="max-w-4xl mx-auto px-4 py-4">
        <div className="flex justify-between items-center gap-4">
          <div className="flex gap-2">
            {currentStep > 0 && (
              <Button
                variant="outline"
                onClick={onPrevious}
                iconName="ChevronLeft"
                iconPosition="left"
              >
                Previous
              </Button>
            )}
          </div>

          <div className="flex gap-2">
            <Button
              variant="ghost"
              onClick={onSave}
              loading={isSaving}
              disabled={isSaving}
              iconName="Save"
              iconPosition="left"
            >
              Save Progress
            </Button>

            {!isFinalStep ? (
              <Button
                variant="default"
                onClick={onNext}
                iconName="ChevronRight"
                iconPosition="right"
              >
                Next Step
              </Button>
            ) : (
              <Button
                variant="success"
                onClick={onNext}
                disabled={!isValid}
                iconName="CheckCircle"
                iconPosition="right"
              >
                Submit Application
              </Button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default FormNavigation;